export default __webpack_public_path__ + "static/media/mamut_logo.9e98bbfe.svg";